import { CommonModule } from '@angular/common';
import { Component, OnInit, Input, ViewChild, ElementRef, OnDestroy, AfterViewInit, Renderer2 } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Observable, Subscription } from 'rxjs';
import { ICONS } from '../_helpers/icons.constants';

@Component({
    selector: 'app-watch-video',
    templateUrl: './watch-video.component.html',
    styleUrls: ['./watch-video.component.scss'],
    standalone: true,
    imports: [CommonModule, TranslateModule]
})
export class WatchVideoComponent implements OnInit, AfterViewInit, OnDestroy {
  param: any;
  check: any;
  UrlFeed: any;
  isShowClose: string;
  setClass: string;
  showLoading = true;
  icons = ICONS;
  private eventsSubscription: Subscription;

  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('modal') modalRef: ElementRef;

  @Input() events: Observable<void>;
  @Input('VideoUrl') VideoUrl: any;
  @Input() isIconHide: boolean = false;
  @Input() href: any;

  constructor(private renderer: Renderer2) {

  }

  ngAfterViewInit() {
    // Move modal element to document.body so it isn't clipped by parent containers
    try {
      if (this.modalRef && this.modalRef.nativeElement) {
        this.renderer.appendChild(document.body, this.modalRef.nativeElement);
      }
    } catch (e) {
      // ignore DOM errors in non-browser environments
    }
  }

  ngOnInit() {
    this.showLoading = true;
    if (this.events) {
      this.eventsSubscription = this.events.subscribe(() => this.showVideo());
    }
  }

  ngOnDestroy() {
    if (this.eventsSubscription) {
      this.eventsSubscription.unsubscribe();
    }
    // Remove modal from body if we moved it
    try {
      if (this.modalRef && this.modalRef.nativeElement && this.modalRef.nativeElement.parentNode === document.body) {
        this.renderer.removeChild(document.body, this.modalRef.nativeElement);
      }
    } catch (e) {
      // ignore
    }
  }

  close(value) {
    this.check = value;
    var iframe = document.querySelector('iframe');

    if (iframe) {
      var iframeSrc = iframe.src;
      iframe.src = iframeSrc;

    }
    else {
      iframe.src = 'https://www.youtube.com/embed/AIblq657VTg?list=PLugzlMICZR8h2n2KFLeVT_J6EURDNWb_O';
    }

  }

  afterHidden(value) {
    // your code here
    this.check = value;
    var iframe = document.querySelector('iframe');

    if (iframe) {
      var iframeSrc = iframe.src;
      iframe.src = iframeSrc;

    }
  }

  IsvideoActive(value) {
    this.check = value;
    var iframe = document.querySelector('iframe');
    this.setClass = iframe.src.indexOf('vimeo') > -1 ? 'video-height-vimeo' : 'video-height-youtube';

  }

  showVideo() {
    this.IsvideoActive(true);
    let inputElement: HTMLElement = this.fileInput.nativeElement as HTMLElement;
    inputElement.click();
  }
  showVideofromother(value) {
    this.check = value;
    var iframe = document.querySelector('iframe');
    this.setClass = iframe.src.indexOf('vimeo') > -1 ? 'video-height-vimeo' : 'video-height-youtube';
    let inputElement: HTMLElement = this.fileInput.nativeElement as HTMLElement;
    inputElement.click();

  }

  onLoad() {
    setTimeout(() => {
      this.showLoading = false;
  }, 2500);
    
  }

}



